export default __webpack_public_path__ + "68e45b6bfe3a42f4e654d31d9526b104.png";